import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Switch, Col, Row, InputNumber } from 'antd';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import {
	createCheckInLocationItems,
	updateCheckInLocationItems,
} from 'services/settings/lookup_table/checkinLocation';

const CheckInLocationForm = ({ buttonNames, selecetedData, onDrawerClose, onSuccessCreate, onSuccessUpdate }) => {
	console.log(selecetedData);

	const onFinish = async values => {
		const payload = {
			locationName: values.locationName ? values.locationName.toUpperCase() : '',
			sort: values.sort,
			is_active: values.is_active === true ? 1 : 0,
		};

		console.log(payload);

		if (buttonNames === 'ADD') {
			const created = await createCheckInLocationItems(payload);
			if (created) {
				onSuccessCreate();
			}
		} else {
			payload.locationID = selecetedData.locationID;
			const updated = await updateCheckInLocationItems(payload);
			if (updated) {
				onSuccessUpdate();
			}
		}
	};

	return (
		<div>
			<Form
				layout="vertical"
				onFinish={onFinish}
				initialValues={{
					locationName: selecetedData ? selecetedData.locationName : null,
					sort: selecetedData ? selecetedData.sort : null,
					is_active: selecetedData ? (selecetedData.isActive === 1 ? true : false) : true,
				}}
			>
				<Row>
					<Col span={4}>
						<Form.Item>
							<label>ACTIVE:</label>
						</Form.Item>
					</Col>

					<Col span={6}>
						<Form.Item name="is_active" valuePropName="checked">
							<Switch disabled={buttonNames === 'ADD'} />
						</Form.Item>
					</Col>
				</Row>
				<Form.Item
					label="LOCATION NAME"
					name="locationName"
					rules={[{ required: true, message: 'This field is required' }]}
				>
					<Input maxLength={254} style={{ textTransform: 'uppercase' }} />
				</Form.Item>
				<section className="drawerFooter">
					<Button shape="round" onClick={onDrawerClose} style={{ marginRight: 8, width: 120 }}>
						CANCEL
					</Button>
					<Button type="primary" shape="round" style={{ margin: 10, width: 120 }} htmlType="submit">
						{buttonNames}
					</Button>
				</section>
			</Form>
		</div>
	);
};

export default CheckInLocationForm;
